import { Routes, RouterModule } from '@angular/router'
import { LoginComponent } from './login/login.component'
import { NgModule } from '@angular/core'
import { NbAuthComponent } from '@nebular/auth'
import { RouterPath } from '../../config/global-const'
import { FacebookOauthCallbackComponent } from './oauth-callback/facebook/facebook-oauth-callback.component'
import { GoogleOauthCallbackComponent } from './oauth-callback/google/google-oauth-callback.component'
import { AppleOauthCallbackComponent } from './oauth-callback/apple/apple-oauth-callback.component'

const AuthRoutes: Routes = [
    {
        path: '',
        component: NbAuthComponent,
        children: [
            {
                path: '',
                redirectTo: RouterPath.AUTH.LOGIN.PATH,
            },
            {
                path: RouterPath.AUTH.LOGIN.PATH,
                component: LoginComponent,
            },
        ],
    },
    {
        path: RouterPath.AUTH.GOOGLE_CALLBACK.PATH,
        component: GoogleOauthCallbackComponent,
    },
    {
        path: RouterPath.AUTH.FACEBOOK_CALLBACK.PATH,
        component: FacebookOauthCallbackComponent,
    },
    {
        path: RouterPath.AUTH.APPLE_CALLBACK.PATH,
        component: AppleOauthCallbackComponent,
    },
]

@NgModule({
    imports: [RouterModule.forChild(AuthRoutes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
